import { useState } from 'react'
import type { Worker, Video } from '../data/types'

interface AdminPanelProps {
  initialWorkers: Worker[]
  initialVideos: Video[]
}

export default function AdminPanel({ initialWorkers, initialVideos }: AdminPanelProps) {
  const [workers, setWorkers] = useState(initialWorkers)
  const [search, setSearch] = useState('')
  const [tab, setTab] = useState('workers')

  const filteredWorkers = workers.filter(w =>
    w.firstName.toLowerCase().includes(search.toLowerCase()) ||
    w.profession.toLowerCase().includes(search.toLowerCase())
  )

  const stats = {
    total: workers.length,
    published: workers.filter(w => w.status === 'published').length,
    hidden: workers.filter(w => w.status === 'hidden').length,
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f3f4f6' }}>
      {/* Top Bar */}
      <div style={{ background: 'white', borderBottom: '1px solid #e5e7eb', padding: '1rem' }}>
        <h1 style={{ margin: 0, fontSize: '1.125rem', fontWeight: 800, color: '#111' }}>Content Manager</h1>
        <p style={{ margin: '4px 0 12px', fontSize: '0.75rem', color: '666' }}>Admin Dashboard • {stats.published} published</p>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            type="text"
            placeholder="Search workers..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ flex: 1, padding: '10px 14px', borderRadius: 10, border: '1px solid #e5e7eb', fontSize: 14, outline: 'none' }}
          />
          <button
            onClick={() => alert('Add Worker modal would open')}
            style={{ padding: '10px 18px', background: '#111827', color: 'white', borderRadius: 10, fontWeight: 600, fontSize: 13, border: 'none', cursor: 'pointer' }}
          >
            + Add
          </button>
        </div>

        <div style={{ display: 'flex', marginTop: 16, borderBottom: '1px solid #e5e7eb' }}>
          {[
            { id: 'workers', label: 'Workers', count: stats.total },
            { id: 'requests', label: 'Requests', count: 0 },
            { id: 'settings', label: 'Settings', count: null },
          ].map(t => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              style={{
                flex: 1, padding: '12px', textAlign: 'center',
                borderBottom: tab === t.id ? '2px solid #111827' : 'none',
                color: tab === t.id ? '#111827' : '666',
                fontWeight: 600, fontSize: 14, background: 'none', border: 'none',
                cursor: 'pointer',
              }}
            >
              {t.label} {t.count !== null && <span style={{ marginLeft: 4, padding: '2px 8px', background: tab === t.id ? '#111827' : '#e5e7eb', color: tab === t.id ? 'white' : '666', borderRadius: 999, fontSize: 11 }}>{t.count}</span>}
            </button>
          ))}
        </div>
      </div>

      <div style={{ padding: '16px' }}>
        {/* Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '16px' }}>
          {[
            { label: 'Total Workers', value: stats.total },
            { label: 'Published', value: stats.published },
            { label: 'Hidden', value: stats.hidden },
          ].map(stat => (
            <div key={stat.label} style={{ background: 'white', borderRadius: 12, padding: '1rem', border: '1px solid #e5e7eb' }}>
              <p style={{ margin: 0, fontSize: '0.7rem', color: '888' }}>{stat.label}</p>
              <p style={{ margin: '4px 0 0', fontSize: '1.75rem', fontWeight: 800, color: '#111' }}>{stat.value}</p>
            </div>
          ))}
        </div>

        {/* Worker List */}
        <div style={{ background: 'white', borderRadius: 16, overflow: 'hidden', border: '1px solid #e5e7eb' }}>
          {filteredWorkers.map((worker, i) => {
            const isPublished = worker.status === 'published'
            const video = initialVideos.find(v => v.id === worker.heroVideoId)
            return (
              <div
                key={worker.id}
                onClick={() => alert(`Edit ${worker.firstName} - modal would open`)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '16px',
                  borderTop: i > 0 ? '1px solid #f0f0f5' : 'none',
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#fafafa' }}
                onMouseLeave={e => { e.currentTarget.style.background = 'white' }}
              >
                {video && (
                  <img src={video.posterUrl} alt="" style={{ width: 48, height: 48, borderRadius: 10, objectFit: 'cover', flexShrink: 0 }} />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
                    <p style={{ margin: 0, fontWeight: 700, fontSize: 15, color: '#111' }}>{worker.firstName}</p>
                    <span style={{
                      width: 8, height: 8, borderRadius: 4,
                      background: isPublished ? '#22c55e' : '#9ca3af',
                    }} />
                  </div>
                  <p style={{ margin: 0, fontSize: 13, color: '888' }}>{worker.profession} • {worker.yearsOfExperience}yr • {worker.nationality}</p>
                </div>

                <button
                  onClick={(e) => {
                    e.stopPropagation()
                    setWorkers(ws => ws.map(w =>
                      w.id === worker.id ? { ...w, status: isPublished ? 'hidden' : 'published' } : w
                    ))
                  }}
                  style={{
                    padding: '6px 14px',
                    borderRadius: 8,
                    fontSize: 12,
                    fontWeight: 600,
                    border: 'none',
                    cursor: 'pointer',
                    background: isPublished ? '#fef2f2' : '#f0fdf4',
                    color: isPublished ? '#ef4444' : '#22c55e',
                  }}
                >
                  {isPublished ? 'Hide' : 'Show'}
                </button>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
